<script lang="ts" generics="TransitionInConfig, TransitionOutConfig">
    import MediaImageUrl from './MediaImageUrl.svelte';
    import Img from '$components/Transition/Img.svelte';
    import type { TransitionsInOut } from '$lib/utils/transition.js';

    type FormatSet = Array<string | [string, string]>;

    export let mediaId: number;
    export let format: string;
    export let formatSet: FormatSet | null = null;

    let className = '';
    export { className as class };

    export let transitions: TransitionsInOut<TransitionInConfig, TransitionOutConfig> =
        {};

    export let fallbackAlt: string | null = null;
    export let fallbackTitle: string | null = null;

    export let alt: string | null = null;
    export let title: string | null = null;
    export let style: string | undefined = undefined;

    function srcset(urlMedia: (format: string) => string, formatSet: FormatSet | null) {
        if (formatSet == null || formatSet.length == 0) {
            return undefined;
        }
        const set = [];
        for (const format of formatSet) {
            if (typeof format === 'string') {
                set.push(encodeURI(urlMedia(format)));
            } else {
                const [_format, _modifier] = format;
                set.push(`${encodeURI(urlMedia(_format))} ${_modifier}`);
            }
        }
        return set.join(', ');
    }
</script>

<MediaImageUrl {mediaId}>
    <Img
        slot="default"
        let:urlMedia
        let:alt={defaultAlt}
        let:title={defaultTitle}
        let:width
        let:height
        {transitions}
        class={className}
        src={urlMedia(format)}
        srcset={srcset(urlMedia, formatSet)}
        alt={alt != null ? alt : (defaultAlt ?? fallbackAlt)}
        title={title != null ? title : (defaultTitle ?? fallbackTitle)}
        loading="lazy"
        {width}
        {height}
        {style}
    />
</MediaImageUrl>
